/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsEvent } from '@shure/shared/models';
export class DeviceOnlineAnalyticsEvent implements AnalyticsEvent {
	public readonly event = 'device_online';
	public readonly properties: {
		hardware_id: string;
		interface_version: string;
		model: string;
		virtual: boolean;
		firmware_version: string;
	};
	constructor(
		hardwareId: string | undefined,
		interfaceVersion: string | undefined,
		model: string | undefined,
		virtual: boolean | undefined,
		firmwareVersion: string | undefined
	) {
		this.properties = {
			hardware_id: hardwareId ?? '',
			interface_version: interfaceVersion ?? '',
			model: model ?? '',
			virtual: virtual ?? true,
			firmware_version: firmwareVersion ?? ''
		};
	}
}
